module.exports = __webpack_public_path__ + "static/application-9aad94a123ba5508ebaa84a195610837.jpg";